import { render, staticRenderFns } from "./TaskUpdateStatusModal.vue?vue&type=template&id=878eb6ca&"
import script from "./TaskUpdateStatusModal.vue?vue&type=script&lang=js&"
export * from "./TaskUpdateStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports